import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  notification: PropTypes.object.isRequired,
};

const CrmCrossCheckNotification = ({ notification: { target: { manufacturer, serial_number } } }) => {
  return (
    <div><b>Device {manufacturer} ({serial_number})</b> is due for a cross-check test.</div>
  );
};

CrmCrossCheckNotification.propTypes = propTypes;

export default CrmCrossCheckNotification;



// WEBPACK FOOTER //
// ./src/features/dashboard/notification-types/CrmCrossCheckNotification.js